<template>
  <div class="aiChatDetay">
    <div class="aiChatDetayBody" :class="Yapifen?'Yapifen':''" id="aiBotChat">
      <div :class="c.Tur" v-for="c in Chat" v-if="Start">
        <el-tooltip v-if="!Yapifen" class="item" effect="dark"
                    :content="c.Gorulme?'Okunma Tarihi: '+c.Gorulme:'Henüz görülmedi'"
                    placement="left">
          <p v-html="c.Icerik"></p>
        </el-tooltip>
        <p v-if="Yapifen" v-html="c.Icerik"></p>
        <small :class="c.Gorulme?'aiGoruldu':''">
          <i class="el-icon-time"></i> {{ c.Tarih }}
        </small>
        <small v-if="Yapifen"> <i class="el-icon-time"></i> {{ c.Tarih }}</small>
      </div>
    </div>
    <div v-if="!Yapifen" class="aiChatDetayInput">
      <el-input @keyup.enter.native="Gonder" placeholder="Mesajınızı yazınız" v-model="Mesaj">
      </el-input>
      <a @click="Gonder"><i class="el-icon-chat-line-square"></i> </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['Data'],
  data() {
    return {
      Yapifen: false,
      Mesaj: null,
      Start: true,
      lo: true,
      Chat: null
    }
  },
  methods: {
    Gonder() {
      if (this.Mesaj) {
        this.lo = true
        var SendMesaj = this.Mesaj
        this.Mesaj = null
        this.$store.dispatch("Post", {Mesaj: SendMesaj, path: '_chat/mesaj/' + this.Data.id})
          .then(response => {
            if (response.Durum == "OK") {
              if (this.Start) this.SayfaYukle();
              this.Mesaj = null
              this.lo = false
            } else {
              this.$message.error(response.Mesaj)
            }
          })
      } else {
        this.$message.error("Mesaj boş bırakılamaz")
      }
    },
    YapifenGetir() {

      this.$store.dispatch("Get", {path: 'muhasebe/apiborc'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Chat = response.Chat
          }
        });

    },
    SayfaYukle() {
      if (this.Start && this.Chat) {
        setTimeout(function () {
          var div = document.getElementById("aiBotChat");
          div.scrollTop = div.scrollHeight - div.clientHeight;
        }, 5);
      }

      this.$store.dispatch("Get", {path: '_chat/detay/' + this.Data.id})
        .then(response => {
          if (response.Durum == "OK") {
            this.Chat = response.Chat
            setTimeout(() => {
              if (this.Start) this.SayfaYukle();
            }, 5000);

          } else {
            this.$message.error(response.Mesaj)
          }
        })
    },
  },
  created() {
    if (this.Data != 'Yapifen') {
      this.SayfaYukle();
      this.Yapifen = false;
    } else {
      this.YapifenGetir();
      this.Yapifen = true;
    }
    // console.log(this.Data);
    setTimeout(function () {
      var div = document.getElementById("aiBotChat");
      div.scrollTop = div.scrollHeight - div.clientHeight;
    }, 500);

  },
  destroyed() {
    this.Start = false;
    this.Chat = null;
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Chat/ChatDetay.vue